const CHECKOUT_SIGN_UP = 'checkout-container-signup'
const CHECKOUT_SHIPPING = 'checkout-container-shipping'
const CHECKOUT_PAYMENT = 'checkout-container-payment'
const CHECKOUT_RELOAD_SHIPPING = 'chekcout-reload-shipping'
const CHECKOUT_RESET_PAYMENT = 'checkout-reset-payment'
const CHECKOUT_RESET_SHIPPING = 'checkout-reset-shipping'

export {
  CHECKOUT_SIGN_UP,
  CHECKOUT_SHIPPING,
  CHECKOUT_PAYMENT,
  CHECKOUT_RELOAD_SHIPPING,
  CHECKOUT_RESET_PAYMENT,
  CHECKOUT_RESET_SHIPPING
}
